<div class="flex gap-2">
  @for (_ of _steps(); track $index) {
    <div
      class="size-5 rounded-full bg-white transition-all"
      [style.scale]="index() === $index ? 1 : 0.75"
      [style.opacity]="index() === $index ? 1 : 0.1"
    ></div>
  }
</div>
